import { useEffect, useSyncExternalStore } from "react";
import {
  DEFAULT_LANGUAGE,
  getLanguage,
  setLanguage,
  subscribeLanguage,
  syncDocumentLanguage,
} from "./messages";

export const useLanguage = () => {
  const language = useSyncExternalStore(subscribeLanguage, getLanguage, () => DEFAULT_LANGUAGE);
  useEffect(syncDocumentLanguage, [language]);
  return { language, setLanguage };
};
